import { request } from '../utils/request'
import { querystring } from '../utils/index'

export default {
  getgoodsreturns: option =>
    request('v1/goodsreturn/getgoodsreturns', option, true, false), // 退货单列表
  getgoodsreturn: option => {
    const urls = querystring(option)
    return request('v1/goodsreturn/getgoodsreturn' + urls, {}, true, false) // 查询退货单
  },
  addgoodsreturnbynotag: option =>
    request('v1/goodsreturn/addgoodsreturnbynotag', option, true, false), // 新增无码退货单
  submitgoodsreturn: option =>
    request('v1/goodsreturn/submitgoodsreturn', option, true, false), // 提交退货单
  downloadreturntags: option => {
    const urls = querystring(option)
    return request('v1/goodsreturn/downloadreturntags' + urls, {}, true, false, true)// 下载退货单标签码
  },
  addpostsaleorder: option =>
    request('v1/postsaleorder/addpostsaleorder', option, true, false), // 新增售后工单
  getpostsaleorders: option =>
    request('v1/postsaleorder/getpostsaleorders', option, true, false), // 退货单列表
  closepostsaleorder: option => {
    const urls = querystring(option)
    return request('v1/postsaleorder/closepostsaleorder' + urls, {}, true, false) // 查询退货单
  }
}
